export default function ({ store, route, redirect, res }) {
  const activeAccount = store.state.auth.activeAccount;
  if (helpers.isEmpty(activeAccount)) {
    return redirect('/login')
  }

  const active_account_permissions = activeAccount.permissionNames;

  const is_pass = route.meta.some((meta) => {
    if (meta.account_permission_names !== undefined) {
      return collect(meta.account_permission_names).diff(active_account_permissions).count() == 0
    }

    return false
  });

  if (!is_pass) {
   return redirect('/panel');
  }
}
